// 卡密相关API
import httpClient from '../http'
import { API_ENDPOINTS } from '../config'

export const cardsApi = {
  // 激活卡密
  activate: data => httpClient.post(API_ENDPOINTS.CARDS.ACTIVATE, data),

  // 检查卡密
  check: data => httpClient.post(API_ENDPOINTS.CARDS.CHECK, data),

  // 生成卡密
  generate: data => httpClient.post(API_ENDPOINTS.CARDS.GENERATE, data),

  // 获取卡密列表
  list: params => httpClient.get(API_ENDPOINTS.CARDS.LIST, { params }),

  // 删除卡密
  delete: data => httpClient.delete(API_ENDPOINTS.CARDS.DELETE, { data }),

  // 延期卡密
  extend: data => httpClient.post(API_ENDPOINTS.CARDS.EXTEND, data),

  // 分配卡密
  assign: data => httpClient.post(API_ENDPOINTS.CARDS.ASSIGN, data)
}
